import { useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { routes } from '../routes/paths'

const ROOT_PATHS = [routes.main, routes.profile, routes.games]

export const useBackButton = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const tg = window?.Telegram?.WebApp
    const backButtonSupported = tg?.BackButton && tg?.isVersionAtLeast?.('6.1')
    const isRoot = ROOT_PATHS.includes(location.pathname)

    const handleBack = useCallback(() => {
        if (location.pathname.startsWith('/admin/') && location.pathname !== routes.admin) {
            navigate(routes.admin)
        } else if (location.pathname === routes.admin) {
            navigate(routes.profile)
        } else if ([routes.battle, routes.mines, routes.advent].includes(location.pathname)) {
            navigate(routes.games)
        } else if (location.pathname === routes.userProfile) {
            navigate(routes.profile)
        } else {
            navigate(routes.main)
        }
    }, [location.pathname, navigate])

    useEffect(() => {
        if (!backButtonSupported) return

        if (isRoot) {
            tg.BackButton.hide()
        } else {
            tg.BackButton.show()
            tg.BackButton.onClick(handleBack)
        }

        return () => {
            if (backButtonSupported) {
                tg.BackButton.offClick(handleBack)
            }
        }
    }, [tg, backButtonSupported, isRoot, handleBack])
}
